<template>
  <div>
    <el-form-item
      :label="field.name + '：'"
      label-width="110px"
      id="image-list"
    >
      <div class="item-list">
        <div
          class="link-name"
          v-text="config[field.key]['activity_name']"
        ></div>
        <el-button size="small" @click="removeArticleItem" class="del-btn"
          >删除
        </el-button>
        <el-button size="small" @click="openDialog">添加活动</el-button>
      </div>
    </el-form-item>
    <el-dialog
      title="请选择活动"
      :visible.sync="dialog.visible"
      @close="closeDialog"
    >
      <div class="select-active-dialog" v-if="dialog.visible">
        <active-list
          :url="tableList.url"
          @close="closeDialog"
          :params="tableList.params"
          :multi="tableList.multi"
          @unSelect="unSelect"
          @select="select"
          :pageData="pageData"
        ></active-list>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.item-list {
  margin-top: -5px;
}
.item {
  cursor: pointer;
  padding: 5px 5px 5px 10px;
  &:hover {
    background: #f5f7fa;
  }
}
.link-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  padding-right: 20px;
}
.del-btn {
  height: 32px;
  margin-top: 4px;
}
.select-active-dialog {
  overflow: auto;
  height: 600px;
}
</style>

<script>
import Util from "@/js/util";
import _ from "lodash";
import draggable from "vuedraggable";
export default {
  name: "tms-type-select-active",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    // config: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // },
    // pageData: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // }
  },
  computed: {
    // 右侧组件数据初始化
    config() {
      return this.$store.state.tms.config;
    },
    pageData() {
      return this.$store.state.tms.pageData;
    },
  },
  data() {
    return {
      dialog: {
        visible: false,
      },
      linkNameList: {},
      currentIndex: 0,
      activeName: "normal",
      tableList: {
        url: "ec/b/operation/activity/list/tms",
        multi: false,
        params: {},
      },
    };
  },

  components: {
    draggable,
  },

  created() {
    if (this.pageData.app_type == "seller") {
      console.log("选择卖家商品");
    } else {
      console.log("选择买家商品");
    }
  },

  methods: {
    openDialog() {
      this.dialog.visible = true;
    },
    removeArticleItem() {
      this.config[this.field.key] = {};
      this.config.link_data = [];
    },
    handleUpload(src, index) {
      this.$set(this.config[this.field.key][index], image_url, src);
    },
    openDialog(index) {
      this.currentIndex = index;
      this.dialog.visible = true;
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    select(row) {
      let item = _.cloneDeep(row);
      delete item.detail;
      item.cms_url = "/cms/page/biz/item.html?id=" + item.id;
      this.config[this.field.key] = item;
      this.config.link_data = [];
    },
    unSelect(row, index) {
      this.config[this.field.key].splice(index, 1);
    },
  },
};
</script>
